import { Box, Typography } from "@mui/material";

export default function TermsPage() {
	return (
		<Box sx={{ p: 2 }}>
			<Typography variant="h4" component="h1" gutterBottom>
				利用規約管理
			</Typography>
			<Typography variant="body1">左のメニューから管理する利用規約を選択してください。</Typography>
		</Box>
	);
}
